import { render, staticRenderFns } from "./UserPositionModal.vue?vue&type=template&id=7ed548e2&scoped=true"
import script from "./UserPositionModal.vue?vue&type=script&lang=js"
export * from "./UserPositionModal.vue?vue&type=script&lang=js"
import style0 from "./UserPositionModal.vue?vue&type=style&index=0&id=7ed548e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed548e2",
  null
  
)

export default component.exports